@if (sessionStore.currentSession() === undefined) {
  <app-loading-spinner class="session-loading"></app-loading-spinner>
} @else {
  <router-outlet></router-outlet>
}